import React from 'react';
import { NumberInput, DropdownSelector } from 'hyperdb-utils';
import GroupForm from '../modules/inventory/propertyGroup/components/Form';
import CheckinOutForm from '../modules/daily-rental/check-in-out-ruleset/components/Form';
import CancellationPolicyForm from '../modules/daily-rental/cancellation-policy/components/Form';

const InventorySettings = ({ api, propertyGroup, checkInOutRuleset, cancellationPolicy, onChange }) => {
  return (
    <div>
      <fieldset>
        <legend>Default property group</legend>
        <GroupForm objectData={ propertyGroup } onChange={ onChange.bind(null, 'propertyGroup') } />
      </fieldset>
      <fieldset>
        <legend>Default checkin/out ruleset</legend>
        <CheckinOutForm objectData={ checkInOutRuleset } onChange={ onChange.bind(null, 'checkInOutRuleset') } />
      </fieldset>
      <fieldset>
        <legend>Default cancellation policy</legend>
        <CancellationPolicyForm { ...api.getState('cancellationPolicy') } objectData={ cancellationPolicy } onChange={ onChange.bind(null, 'cancellationPolicy') } api={api} />
      </fieldset>
    </div>
  )
};

export default InventorySettings;



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/InventorySettings.jsx